<template>
  <div>
    <div class="text-right mt-3">
      <action-button
        v-if="showRestartStatus"
        class="outline-success btn-block-xs-only mr-3"
        i="fas fa-undo"
        text="Regresar Estatus"
        @click="restartEstatusHandler"
      />

      <action-button
        v-if="showRemoveFiles"
        class="outline-danger btn-block-xs-only mr-3"
        i="fas fa-times-circle"
        text="Eliminar Archivos de Pagos"
        @click="removeFilesHandler"
      />
    </div>
    <div class="container-fluid mx-0 px-0 w-100">
      <div class="row no-gutters">
        <div :class="isThisJornalPaid ? 'col-md-8' : 'col-md-12'">
          <section-title has-line title="Información de Jornal" />
        </div>
        <div class="col-md-4 d-flex justify-content-md-end mb-4 mb-md-0">
          <template v-if="isThisJornalPaid">
            <span class="d-flex align-items-center">
              <label
                class="color-secondary-6 font-14 font-weight-normal mb-0 mr-1"
              >
                Fecha Pagado:
              </label>
              <span>{{ value.paymentDate | date }}</span>
            </span>
          </template>
        </div>
      </div>
    </div>
    <div class="bg-secondary-3 rounded p-2">
      <div class="row mt-2 mb-3 pr-0 pr-md-5 pr-sm-0">
        <div class="col col-sm col-6">
          <div
            class="d-flex justify-content-start align-items-start align-items-md-center item-items-sm-start"
          >
            <icon-view
              class="icon-view-extended"
              icon="fas fa-file-invoice-dollar mt-2"
              icon-background="#FF7058"
              icon-color="#fff"
              icon-size="20px"
              width=""
            />
            <div class="justify-content-start">
              <div class="color-gray-6 font-14 font-weight-normal">
                Número de Jornal:
              </div>
              <div class="color-black font-weight-bold font-16 mt-1">
                {{ value.paymentJournalNumber }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="col col-sm col-6 d-flex justify-content-center align-items-start align-items-md-center align-items-sm-start"
        >
          <custom-balloon
            :background-color="
              `bg-${getStatusColor(value.paymentJournalStatusId)}`
            "
            class="w-40 mt-1 font-weight-bold font-16 custom-status-extended"
            :text="value.paymentJournalStatusName"
          />
        </div>
        <div
          class="col text-sm-left text-md-right pr-5 ml-5 pl-4 mt-3 mt-md-0 mt-sm-3"
        >
          <div class="color-secondary-6 font-14 font-weight-normal">
            Fecha Creado:
          </div>
          <div class="color-black font-weight-bold font-16">
            {{ value.createDate | date }}
          </div>
        </div>
      </div>
      <div class="row mx-1 pr-0 pr-md-5 pr-sm-0 my-2 py-3 rounded bg-white">
        <div class="col col-sm col-6 text-left text-md-center text-sm-left">
          <div class="color-secondary-6 font-14 font-weight-normal">Pagos:</div>
          <div
            class="color-black font-weight-bold font-16 ml-n0 ml-md-n2 ml-sm-n0"
          >
            {{ value.paymentCount }}
          </div>
        </div>
        <div class="col col-sm col-6 text-left text-md-center text-sm-left">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Procesado:
          </div>
          <div class="color-black font-weight-bold font-16">
            {{ value.processedAmount | price }}
          </div>
        </div>
        <div
          class="col col-sm col-6 text-left text-md-center text-sm-left mt-3 mt-md-0 mt-sm-3"
        >
          <div class="color-secondary-6 font-14 font-weight-normal">
            Pendiente:
          </div>
          <div
            class="color-black font-weight-bold font-16 ml-n0 ml-md-n3 ml-sm-n0"
          >
            {{ value.pendingAmount | price }}
          </div>
        </div>
        <div
          class="col col-sm col-6 text-left text-md-right text-sm-left pr-4 mt-3 mt-md-0 mt-sm-3"
        >
          <div class="color-secondary-6 font-14 font-weight-normal pr-3 mr-2">
            Total:
          </div>
          <div class="color-black font-weight-bold font-16 mr-3">
            {{ value.paymentTotalAmount | price }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import IconView from 'icon-view';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus.js';

export default {
  name: 'JournalInfo',
  components: {
    SectionTitle,
    ActionButton,
    IconView,
    CustomBalloon,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getStatusColor() {
      return (statusId) => {
        switch (statusId) {
          case paymentJournalStatus.Nuevo:
            return 'secondary-23';
          case paymentJournalStatus.Procesado:
          case paymentJournalStatus.ArchivoGenerado:
            return 'secondary-36';
          case paymentJournalStatus.Pagado:
            return 'green-light';
          default:
            return 'secondary-23';
        }
      };
    },
    showRestartStatus() {
      return (
        this.value.paymentJournalStatusId == paymentJournalStatus.Procesado
      );
    },
    showRemoveFiles() {
      return (
        this.value.paymentJournalStatusId ==
          paymentJournalStatus.ArchivoGenerado &&
        this.userHasPermissions(
          'menu.scholarship.jornalpayment.removefilespayments'
        )
      );
    },
    isThisJornalPaid() {
      return this.value.paymentJournalStatusId === paymentJournalStatus.Pagado;
    },
  },
  methods: {
    restartEstatusHandler() {
      this.$emit('restart-status');
    },
    updateJournalHandler() {
      this.$emit('update-journal');
    },
    removeFilesHandler() {
      this.$emit('remove-files');
    },
  },
};
</script>

<style scoped lang="scss">
.custom-icon-view-size {
  width: 100px !important;
  height: 100px !important;
}

::v-deep .icon-view-extended {
  .dot {
    width: 42px !important;
    height: 40px !important;
  }
}

@media only screen and (max-width: 768px) {
  .btn-block-xs-only {
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }
  .custom-status-extended {
    width: 100% !important;
  }
}
</style>
